import React, { Component } from "react";
import { connect } from "react-redux";
import { Translation } from "react-i18next";
import BtnAfterLoadCustomerSucc from "./BtnAfterLoadCustomerSucc";

class BtnCheckLogin extends Component {
  render() {
    const { isLogin, clickLogin, clickNextButtonForCheckEmail } = this.props;

    return (
      <>
        {!isLogin ? (
          <button
            id="checkout_Login_btn"
            className="blockBtn"
            onClick={clickLogin}
          >
            <Translation>{t => <>{t(`checkout.login`)}</>}</Translation>
          </button>
        ) : (
          <BtnAfterLoadCustomerSucc
            clickNextButtonForCheckEmail={clickNextButtonForCheckEmail}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  isLogin: state.login.signed
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BtnCheckLogin);
